import { render, staticRenderFns } from "./buildInStock.vue?vue&type=template&id=36733a9c&scoped=true"
import script from "./buildInStock.vue?vue&type=script&lang=js"
export * from "./buildInStock.vue?vue&type=script&lang=js"
import style0 from "./buildInStock.vue?vue&type=style&index=0&id=36733a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36733a9c",
  null
  
)

export default component.exports